module.exports = __webpack_public_path__ + "img/descending.f81bc036.svg";